<template>
  <div class="row">
    <div class="col">
      <app-loading v-show="loading"></app-loading>
      <div v-show="box.id">
        <h4 class="text-center">{{ today }}</h4>
        <h5><u>ENTRADAS:</u></h5>
        <DiarieTable
          @deleteItem="
            $refs.elPreDelIn.val = $event;
            $refs.elPreDelIn.show();
          "
          :list="validInputs"
          :disabled="disabled"
        ></DiarieTable>
        <button
          class="btn btn-primary mb-3"
          v-show="!disabled"
          @click="
            $refs.elModInp.show();
            $refs.elInForm.reset();
          "
        >
          Registrar ingreso
        </button>
        <h5><u>SALIDAS:</u></h5>
        <DiarieTable
          @deleteItem="
            $refs.elPreDelOu.val = $event;
            $refs.elPreDelOu.show();
          "
          :list="box.outputs"
          :disabled="disabled"
        ></DiarieTable>
        <button
          class="btn btn-primary"
          v-show="!disabled"
          @click="
            $refs.elModForm.show();
            $refs.elForm.reset();
          "
        >
          Registrar gasto
        </button>
      </div>
    </div>

    <div class="col col-lg-6" v-show="!box.id && !loading">
      No tienes caja registradora abierta
    </div>

    <app-modal-basic ref="elModInp">
      <InputForm
        ref="elInForm"
        :cashRegisterId="box.id"
        @submitted="
          $refs.elModInp.hide();
          getCashRegister();
        "
      ></InputForm>
    </app-modal-basic>

    <app-modal-basic ref="elModForm">
      <OutputForm
        ref="elForm"
        :cashRegisterId="box.id"
        @submitted="
          $refs.elModForm.hide();
          getCashRegister();
        "
      ></OutputForm>
    </app-modal-basic>

    <app-modal-yn ref="elPreDelIn" @yes="deleteInput($refs.elPreDelIn.val)">
      <p>Seguro(a) de eliminar el ingreso registrado?</p>
    </app-modal-yn>
    <app-modal-yn ref="elPreDelOu" @yes="deleteOutput($refs.elPreDelOu.val)">
      <p>Seguro(a) de eliminar el egreso registrado?</p>
    </app-modal-yn>
  </div>
</template>
<script>
import { DinnerService } from "./DinnerService";
import { mapState } from "vuex";
//import DiarieTrForm from "./DiarieTrForm.vue";
import OutputForm from "src/lt-module/admin-module/outputs/Form.vue";
import DiarieTable from "./DiarieTable.vue";
import { myMoment } from "src/lt-module/utils/myMoment.js";
import InputForm from "src/lt-module/admin-module/inputs/Form.vue";

export default {
  components: {
    //DiarieTrForm,
    OutputForm,
    DiarieTable,
    InputForm
  },

  // directives
  // filters

  props: {
    autoLoad: {
      default: true
    },
    cashRegisterId: {
      default: null
    },
    disabled: {
      default: false
    }
  },

  data: () => ({
    box: {},
    outputs: [],
    loading: false
    //today: myMoment().format("dddd, LL")
  }),

  computed: {
    validInputs() {
      if (this.box.inputs) {
        return this.box.inputs.filter((x) => x.type_id == 3);
      }
      return [];
    },
    today() {
      if (this.box.cashregister) {
        let day = myMoment(this.box.cashregister.created_at);
        return `${day.format("dddd").toUpperCase()}, ${day.format("LL")}`;
      }
      return "";
    },

    // outputs() {
    //   return this.box.outputs || [];
    // },
    total() {
      return this.outputs
        .map((x) => parseFloat(x.quantity))
        .reduce((p, c) => p + c, 0);
    },

    ...mapState({
      see_input: (s) => s.dinner.client.see_input
    })
  },

  watch: {
    //
  },

  mounted() {
    if (this.autoLoad) {
      this.getCashRegister();
    }
  },

  methods: {
    async getCashRegister() {
      let box = {};
      this.loading = true;
      if (this.autoLoad) {
        box = await DinnerService.getCashBox();
      } else {
        box = await DinnerService.getCashRegister(this.cashRegisterId);
      }
      this.loading = false;
      this.setBox(box);
    },
    setBox(box) {
      this.box = box;
      this.outputs = this.box.outputs;
    },
    deleteInput(inputId) {
      DinnerService.deleteInput(inputId).then(() => {
        this.getCashRegister();
      });
    },
    deleteOutput(outputId) {
      DinnerService.deleteOutput(outputId).then(() => {
        this.getCashRegister();
      });
    }
  }
};
</script>

<style scoped></style>
